export default __webpack_public_path__ + "static/media/e.88905395.mp3";